import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { imsiResetColumns } from "../../../../constants/lineListColumns";
import { __getReset } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "last_updated"];

const IMSIResetBatch = () => (
  <BatchDetail
    title="Reset"
    apiGet={__getReset}
    columnsFactory={imsiResetColumns}
    copyKeys={COPY_KEYS}
  />
);

export default IMSIResetBatch;
